import { createCrudActions } from '../utils/crudGenerator';

const formatClientproducts = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.displayName || item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchClientproducts,
    create: createClientproduct,
    update: updateClientproduct,
    delete: deleteClientproducts
} = createCrudActions('CLIENTPRODUCT', "ProductosCliente", formatClientproducts);
